import { render } from "./low_stock.vue?vue&type=template&id=1c189984&scoped=true"
import script from "./low_stock.vue?vue&type=script&lang=js"
export * from "./low_stock.vue?vue&type=script&lang=js"

import "./low_stock.vue?vue&type=style&index=0&id=1c189984&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c189984"]])

export default __exports__